<template>
  <div style="background-color:#f4f5f5; height:100%; max-width: 640px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false"  @click-left="onClickLeft" safe-area-inset-top>
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">{{ title }}</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <van-form  @submit="onSubmit" ref="Form">
      <van-row>
        <van-col class="label_name" span="12">
          <van-field
            v-model="Form.last_name"
            name="last_name"
            label="姓氏"
            maxlength="3"
            placeholder="請輸入華文姓氏"
            :rules="[{ required: true, message: '請填寫華文姓氏!' }]"
          />
        </van-col>
        <van-col class="label_name" span="12">
          <van-field
            v-model="Form.first_name"
            name="first_name"
            label="名字"
            maxlength="4"
            placeholder="請輸入華文名字"
            :rules="[{ required: true, message: '請填寫華文名字!' }]"
          />
        </van-col>
      </van-row>
      <van-field
        v-if="edit"
        class="label_name"
        v-model="Form.phone"
        type="number"
        name="validator"
        label="電話"
        left-icon="phone-o"
        maxlength="10"
        placeholder="09XXXXXXXX"
        :rules="[{ validator, message: '請填寫09開頭電話號碼' }]"
        readonly
      />
      <van-field
        v-if="edit == false"
        v-model="Form.phone"
        class="label_name"
        type="number"
        name="validator"
        label="電話"
        left-icon="phone-o"
        maxlength="10"
        placeholder="09XXXXXXXX"
        @input="handleInputPhone"
        :rules="[{ validator, message: '請填寫09開頭電話號碼' }]"
      />
      <van-row v-if="edit == false">
        <van-col span="16">
          <van-field
            class="label_name"
            v-model="Form.verifycode"
            type="number"
            name="verifycode"
            label="口令"
            left-icon="envelop-o"
            maxlength="4"
            placeholder="簡訊驗證口令"
            :rules="[{ required: true, message: '請填寫簡訊驗證口令' }]"
          />
        </van-col>
        <van-col span="8">
          <van-button type="info" :disabled="banSendSms" loading-text="請稍後..." :loading="loadingSms" @click="sendVerifyCode">獲取簡訊口令</van-button>
        </van-col>
      </van-row>
      <van-field class="label_name" name="radio" label="配送" left-icon="logistics">
        <template #input>
          <van-radio-group v-model="Form.express" direction="horizontal" @change="changeDelivery()">
            <van-radio name="新竹物流" checked-color="#3578e5" >宅配到府</van-radio>
            <van-radio name="7-11" checked-color="#3578e5">7-11</van-radio>
            <van-radio name="全家" checked-color="#3578e5">全家</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="picker"
        :value="value"
        class="label_name"
        label="地區"
        left-icon="location-o"
        placeholder="點擊選擇配送地區"
        :rules="[{ pattern : /^.{5,}$/, message: '請選擇配貨地區' }]"
        @click="showPicker = true"
      />
      <van-popup class="city-pop" get-container="#app" v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          confirm-button-text="確認"
          @confirm="onConfirm"
          @cancel="showPicker = false"
          @change="getvalue"
        />
      </van-popup>
      <van-field
        v-if="Form.deliveryType === '2'"
        readonly
        class="label_name"
        clickable
        name="picker"
        :value="shopvalue"
        label="門店"
        left-icon="shop-o"
        placeholder="點擊選擇配送店鋪"
        @click="oncheckCanShowShop()"
        :rules="[{ pattern : /^.{5,}$/, message: '請選擇配貨店鋪' }]"
      />
      <van-popup v-if="Form.deliveryType === '2'" class="city-pop" get-container="#app" v-model="showShopPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="shopColumn"
          confirm-button-text="確認"
          @confirm="onConfirmShop"
          @cancel="showShopPicker = false"
          ref="ShopPicker"
        />
      </van-popup>
      <van-field
        v-if="Form.deliveryType === '1'"
        v-model="Form.addr"
        class="label_name"
        name="pattern"
        label="地址"
        left-icon="home-o"
        maxlength="80"
        placeholder="詳細的收貨地址"
        :rules="[{ pattern: /^.{5,}$/, message: '請填寫詳細的收貨地址' }]"
      />
    </van-form>
    <div style="bottom: 0px; margin: 5px; background-color: #FFFFFF;">
        <van-button square block type="info" native-type="submit" style="margin-top: 10px;" @click="onSubmit">提交</van-button>
        <van-button square block color="gray" style="margin-top: 10px;" @click="onClickLeft">取消</van-button>
        <van-button v-if="edit" square block type="danger" style="margin-top: 10px;" @click="onDelete">刪除</van-button>
    </div>
  </div>
</template>
<script>
import { Notify, Toast, Dialog } from 'vant'
import { addAddr, getAddr, editAddr, deleteAddr } from '@/api/address'
import {getVerifyCode } from '@/api/user'
import { searchStore } from '@/api/store'
import { getUser } from '@/utils/auth'
// import axios from 'axios'

const cities = {
  '基隆市': ['中正區', '七堵區', '暖暖區', '安樂區', '中山區', '仁愛區', '信義區'],
  '台北市': ['松山區', '信義區', '大安區', '中山區', '中正區', '大同區', '萬華區', '文山區', '南港區', '內湖區', '士林區', '北投區'],
  '新北市': [
    '板橋區', '三重區', '中和區', '永和區', '新莊區', '新店區',
    '樹林區', '土城區', '蘆洲區', '汐止區', '鶯歌區', '三峽區',
    '淡水區', '瑞芳區', '五股區', '泰山區', '林口區', '深坑區',
    '石碇區', '坪林區', '三芝區', '石門區', '八里區', '平溪區',
    '雙溪區', '貢寮區', '金山區', '萬里區', '烏來區'
  ],
  '宜蘭縣': [
    '宜蘭市', '羅東鎮', '蘇澳鎮', '頭城鎮', '礁溪鄉', '壯圍鄉',
    '員山鄉', '冬山鄉', '五結鄉', '三星鄉', '大同鄉', '南澳鄉'
  ],
  '新竹市': ['東區', '北區', '香山區'],
  '新竹縣': ['竹北市', '竹東鎮', '新埔鎮', '關西鎮', '湖口鄉', '新豐鄉', '芎林鄉', '橫山鄉', '北埔鄉', '寶山鄉', '峨眉鄉', '五峰鄉', '尖石鄉'],
  '桃園市': [
    '桃園區', '中壢區', '八德區', '平鎮區', '龜山區', '大溪區',
    '楊梅區', '蘆竹區', '大園區', '龍潭區', '新屋區', '觀音區',
    '復興區'
  ],
  '苗栗縣': [
    '苗栗市', '竹南鎮', '後龍鎮', '頭份市', '造橋鄉', '三灣鄉',
    '頭屋鄉', '南庄鄉', '公館鄉', '西湖鄉', '通霄鎮', '苑裡鎮',
    '銅鑼鄉', '大湖鄉', '三義鄉', '卓蘭鎮', '泰安鄉', '獅潭鄉'
  ],
  '台中市': [
    '中區', '東區', '南區', '西區', '北區', '北屯區', '西屯區', '南屯區',
    '太平區', '大里區', '霧峰區', '烏日區', '豐原區', '后里區',
    '石岡區', '東勢區', '和平區', '新社區', '潭子區', '大雅區',
    '神岡區', '大肚區', '沙鹿區', '龍井區', '梧棲區', '清水區',
    '大甲區', '外埔區', '大安區'
  ],
  '彰化縣': [
    '彰化市', '芬園鄉', '花壇鄉', '秀水鄉', '鹿港鎮', '福興鄉',
    '線西鄉', '和美鎮', '伸港鄉', '員林市', '社頭鄉', '永靖鄉',
    '埔心鄉', '溪湖鎮', '大村鄉', '埔鹽鄉', '田中鎮', '北斗鎮',
    '田尾鄉', '埤頭鄉', '溪州鄉', '竹塘鄉', '二林鎮', '大城鄉',
    '芳苑鄉', '二水鄉'
  ],
  '南投縣': [
    '南投市', '中寮鄉', '草屯鎮', '國姓鄉', '埔里鎮', '仁愛鄉',
    '名間鄉', '集集鎮', '水里鄉', '魚池鄉', '信義鄉', '竹山鎮',
    '鹿谷鄉'
  ],
  '嘉義市': ['東區', '西區'],
  '嘉義縣': [
    '番路鄉', '梅山鄉', '竹崎鄉', '阿里山鄉', '中埔鄉', '大埔鄉',
    '水上鄉', '鹿草鄉', '太保市', '朴子市', '東石鄉', '六腳鄉',
    '新港鄉', '民雄鄉', '大林鎮', '溪口鄉', '義竹鄉', '布袋鎮'
  ],
  '雲林縣': [
    '斗南鎮', '大埤鄉', '虎尾鎮', '土庫鎮', '褒忠鄉', '東勢鄉',
    '臺西鄉', '崙背鄉', '麥寮鄉', '斗六市', '林內鄉', '古坑鄉',
    '莿桐鄉', '西螺鎮', '二崙鄉', '北港鎮', '水林鄉', '口湖鄉',
    '四湖鄉', '元長鄉', '台西鄉'
  ],
  '台南市': [
    '新營區', '安南區', '安平區', '永康區', '北區', '白河區',
    '中西區', '鹽水區', '南區', '柳營區', '東區', '後壁區',
    '東山區', '北門區', '學甲區', '下營區', '六甲區', '楠西區',
    '將軍區', '佳里區', '麻豆區', '官田區', '大內區', '玉井區',
    '南化區', '七股區', '西港區', '安定區', '善化區', '新市區',
    '山上區', '新化區', '關廟區', '歸仁區', '仁德區', '左鎮區', '龍崎區'
  ],
  '高雄市': [
    '鳳山區', '鹽埕區', '鼓山區', '林園區', '大寮區', '左營區',
    '大樹區', '楠梓區', '三民區', '大社區', '新興區', '茂林區',
    '仁武區', '鳥松區', '前金區', '岡山區', '苓雅區', '橋頭區',
    '前鎮區', '燕巢區', '旗津區', '小港區', '阿蓮區', '路竹區',
    '湖內區', '茄萣區', '永安區', '彌陀區', '梓官區', '旗山區',
    '美濃區', '六龜區', '甲仙區', '杉林區', '內門區', '桃源區',
    '田寮區', '那瑪夏區'
  ],
  '屏東縣': [
    '屏東市', '潮州鎮', '東港鎮', '恆春鎮', '萬丹鄉', '長治鄉',
    '麟洛鄉', '九如鄉', '里港鄉', '鹽埔鄉', '高樹鄉', '萬巒鄉',
    '內埔鄉', '竹田鄉', '新埤鄉', '枋寮鄉', '新園鄉', '崁頂鄉',
    '林邊鄉', '南州鄉', '佳冬鄉', '琉球鄉', '車城鄉', '滿州鄉',
    '枋山鄉', '瑪家鄉', '春日鄉', '來義鄉', '牡丹鄉', '獅子鄉',
    '泰武鄉', '霧台鄉', '三地門鄉'
  ],
  '台東縣': [
    '台東市', '成功鎮', '關山鎮', '卑南鄉', '鹿野鄉', '池上鄉',
    '東河鄉', '長濱鄉', '太麻里鄉', '大武鄉', '綠島鄉', '達仁鄉',
    '蘭嶼鄉', '海端鄉', '延平鄉', '金峰鄉'
  ],
  '花蓮縣': [
    '花蓮市', '鳳林鎮', '玉里鎮', '新城鄉', '吉安鄉', '壽豐鄉',
    '光復鄉', '豐濱鄉', '瑞穗鄉', '富里鄉', '秀林鄉', '卓溪鄉',
    '萬榮鄉'
  ]
}
// const street = ['中正路', '北寧路', '和一路', '祥豐街', '新豐街', '義一路', '義二路', '豐稔街', '觀海街']
var shops = ['']

export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      title: '添加收貨資料',
      edit: false,
      showPicker: false,
      showNotify: false,
      showShare: false,
      banSendSms: true,
      showShopPicker: false,
      loadingSms: false,
      value: '',
      shopvalue: '',
      activeNames: [],
      lastcity: {city: '基隆市', region: '中正區'},
      Form: { customer: getUser(), deliveryType: '1', shop: '', street: '', phone: '', city: '', region: '', addr: '', express: '新竹物流', verifycode: '' },
      // columns: [{ values: Object.keys(cities) }, { values: cities['基隆市'] }, { values: street }],
      columns: [{ values: Object.keys(cities) }, { values: cities['基隆市'] }],
      shopColumn: [{ values: shops }]
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        if (route.params.id) {
          this.title = '修改收貨資料'
          this.edit = true
        }
      },
      immediate: true
    }
  },
  created () {
    if (this.$route.params.id) {
      this.getAddrInfo()
    }
  },
  mounted () {
  },
  methods: {
    handleInputPhone () {
      if (/^09[0-9]{8}$/.test(this.Form.phone)) {
        this.banSendSms = false
      } else {
        this.banSendSms = true
      }
    },
    sendVerifyCode () {

      if (!(/^09[0-9]{8}$/.test(this.Form.phone))) {
        Notify({ type: 'warning', message: '請輸入正確的行動電話' })
        return false
      }

      this.loadingSms = true
      this.banSendSms = true

      getVerifyCode({ phone: this.Form.phone }).then(res => {
        if (res.code === 200) {
          Notify({ type: 'success', message: '簡訊已發送成功' })
          Toast('簡訊已發送，請輸入驗證碼');
        } else {
          Notify({ type: 'danger', message: res.message })
          Toast(res.message);
        }
      })

    },
    getAddrInfo () {
      this.Form = { customer: getUser(), deliveryType: '1' }
      getAddr({ customer: getUser(), id: this.$route.params.id }).then(res => {
        if (res.code === 200) {
          this.Form = res.data
          this.value = res.data.city + '/' + res.data.region /* + '/' + res.data.street */
          this.shopvalue = res.data.shop
        }
      })
    },
    onDelete () {
      Dialog.confirm({
        title: '通知',
        message: '資料將徹底刪除，確定刪除改收貨資料嗎?',
        confirmButtonText: '確認',
        confirmButtonColor: 'red'
      })
        .then(() => {
          if (this.edit === true) {
            deleteAddr({ customer: getUser(), id: this.$route.params.id }).then(res => {
              if (res.code === 200) {
                Notify({ type: 'success', message: '刪除地址成功' })
                this.$router.back(-1)
                window.scrollTo(0, 0)
              } else {
                Notify({ type: 'danger', message: res.message })
              }
            })
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    onSubmit () {
      this.$refs.Form.validate().then(() => {
        // 验证通过
        Toast.loading({
          message: '請稍後...',
          forbidClick: true,
          loadingType: 'spinner'
        })
        window.fbq('track', 'InitiateCheckout')
        if (this.edit === true) {
          editAddr(this.Form).then(res => {
            if (res.code === 200) {
              Notify({ type: 'success', message: '修改地址成功' })
              this.$router.back(-1)
              window.scrollTo(0, 0)
            } else {
              Notify({ type: 'danger', message: res.message })
            }
          })
        } else {
          addAddr(this.Form).then(res => {
            if (res.code === 200) {
              Notify({ type: 'success', message: '創建地址成功' })
              this.$router.back(-1)
              window.scrollTo(0, 0)
            } else {
              Notify({ type: 'danger', message: res.message })
            }
          })
        }
      }).catch(() => {
        Notify({ type: 'warning', message: '請完善收貨資料' })
      })
    },
    validator (val) {
      return /^09[0-9]{8}$/.test(val)
    },
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    changeDelivery () {
      if (this.Form.express === '新竹物流') {
        this.Form.deliveryType = '1'
      } else {
        this.Form.deliveryType = '2'
        this.shopvalue = ''
        this.Form.shop = ''
      }
    },
    oncheckCanShowShop () {
      if (this.Form.city === '' || this.Form.region === '') {
        Notify({ type: 'warning', message: '請先選擇配送地區' })
        this.showShopPicker = false
      } else {
        /*
        var config = {'headers': {'Content-Type': 'application/x-www-form-urlencoded'}}
        var data = { commandid: 'SearchStore', city: this.Form.city, town: this.Form.region, roadname: this.Form.street }
        axios.post('/api/emap/EMapSDK.aspx', data, config).then((res) => {
          var parseString = require('xml2js').parseString
          shops = []
          parseString(res.data, function (err, result) {
            console.log(err)
            for (var i = 0; i < result.iMapSDKOutput.GeoPosition.length; i++) {
              shops.push(result.iMapSDKOutput.GeoPosition[i].POIName + '-' + parseInt(result.iMapSDKOutput.GeoPosition[i].POIID) + '-' + result.iMapSDKOutput.GeoPosition[i].Address)
            }
          })
          this.shopColumn = shops
        })
        */
        searchStore({ type: this.Form.express, city: this.Form.city, region: this.Form.region }).then(res => {
          if (res.code === 200) {
            var shops = []
            var data = res.data
            for (let i = 0; i < data.length; i++) {
              var id = data[i].id
              var name = data[i].name
              var address = data[i].address
              address = address.replace(this.Form.city + this.Form.region, '')
              var addr = name + '-' + id + '-' + address
              // var show = name + '-' + address
              shops[i] = addr
            }
            this.shopColumn = shops
          } else {
            Notify({ type: 'danger', message: res.message })
          }
        })
        if (this.shopColumn.length === 0) {
          Notify({ type: 'warning', message: '當前地區沒有可配送的店鋪' })
          this.showShopPicker = false
        } else {
          this.showShopPicker = true
        }
      }
    },
    onConfirm (values) {
      this.value = values[0] + '/' + values[1] /* + '/' + values[2] */
      this.Form.city = values[0]
      this.Form.region = values[1]
      // this.Form.street = values[2]
      this.showPicker = false
      shops = ['']
      this.shopColumn = ['']
      window.fbq('track', 'FindLocation')
    },
    getvalue (picker, values) {
      if (this.lastcity.city === values[0] && this.lastcity.region === values[1]) {
        return
      }
      if (this.lastcity.city !== values[0]) {
        picker.setColumnValues(1, cities[values[0]])
        this.lastcity.city = values[0]
        this.lastcity.region = cities[values[0]][0]
      } else {
        this.lastcity.city = values[0]
        this.lastcity.region = values[1]
      }

      /*
      var config = {'headers': {'Content-Type': 'application/x-www-form-urlencoded'}}
      var data = { commandid: 'SearchRoad', city: this.lastcity.city, town: this.lastcity.region }
      axios.post('/api/emap/EMapSDK.aspx', data, config).then((res) => {
        var street = []
        var parseString = require('xml2js').parseString
        parseString(res.data, function (err, result) {
          console.log(err)
          for (var i = 0; i < result.iMapSDKOutput.RoadName.length; i++) {
            street.push(result.iMapSDKOutput.RoadName[i].rd_name_1[0] + result.iMapSDKOutput.RoadName[i].section_1[0])
          }
        })
        picker.setColumnValues(2, street)
      })
      */
    },
    onConfirmShop (values) {
      this.shopvalue = values
      this.Form.shop = values
      this.showShopPicker = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
  .van-field >>>.van-field__error-message {
    display: none !important;
  }
  .label_name>>>.van-field__label {
    width: 2rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddressInfo.vue